import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { SupplierStatementQuery } from '@/api/handlers/resources/suppliers/requests';
import type { GetSupplierStatementResponse } from '@/api/handlers/resources/suppliers/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

/**
 * Reads `GET /suppliers/{id}/statement` (BOS-120) — the supplier's running
 * account. Disabled until a supplier is selected.
 */
export const useSupplierStatementQuery = (
    supplierId: string | null,
    query: SupplierStatementQuery = {},
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetSupplierStatementResponse>>({
        queryKey: SupplierQueryKeys.statement(supplierId ?? '', query),
        queryFn: () =>
            apiClient.suppliers.getSupplierStatement(supplierId ?? '', query),
        enabled: enabled && supplierId !== null,
        staleTime: 60_000,
    });
};
